import { render, staticRenderFns } from "./SocialSecurityTab.vue?vue&type=template&id=36466fba&scoped=true"
import script from "./SocialSecurityTab.vue?vue&type=script&lang=js"
export * from "./SocialSecurityTab.vue?vue&type=script&lang=js"
import style0 from "./SocialSecurityTab.vue?vue&type=style&index=0&id=36466fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36466fba",
  null
  
)

export default component.exports